import * as toastr from 'toastr/toastr';

window.toastr = toastr;